export default __webpack_public_path__ + "static/media/image3.8499c46c.jpg";